module.exports = __webpack_public_path__ + "img/to_start.dc615731.jpg";